import script from "./goRinSyo0039.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0039.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0039.vue?vue&type=style&index=0&id=75ebad56&lang=scss"

const __exports__ = script;

export default __exports__